import { Injectable } from '@angular/core';
import {StaticDataService} from '../../services/static-data.service';
import {EnumValidValueItemModel} from '../../models/enum/enum-valid-value-item.model';

@Injectable({
  providedIn: 'root'
})
export class TreatmentEndoCanalEnumService {
  toothCanalEnums: EnumValidValueItemModel[];
  pulpStatusEnums: EnumValidValueItemModel[];
  estimatedWorkLengthEnums: EnumValidValueItemModel[];
  referenceEnums: EnumValidValueItemModel[];
  actualWorkLengthEnums: EnumValidValueItemModel[];
  apicalCurv1LocEnums: EnumValidValueItemModel[];
  apicalCurv2LocEnums: EnumValidValueItemModel[];
  apicalCurvEnums: EnumValidValueItemModel[];
  firstFile2BindEnums: EnumValidValueItemModel[];
  masterApicalFileEnums: EnumValidValueItemModel[];
  guttaPerchaEnums: EnumValidValueItemModel[];
  sealerEnums: EnumValidValueItemModel[];
  fillEnums: EnumValidValueItemModel[];
  methodOfObturationEnums: EnumValidValueItemModel[];
  interAptMedEnums: EnumValidValueItemModel[];
  coronal1TypeEnums: EnumValidValueItemModel[];
  coronal2TypeEnums: EnumValidValueItemModel[];
  coronalPostSpaceEnums: EnumValidValueItemModel[];
  sepEnums: EnumValidValueItemModel[];
  fillTypeEnums: EnumValidValueItemModel[];
  fillBrandEnums: EnumValidValueItemModel[];
  fillSizeEnums: EnumValidValueItemModel[];
  fillLocationEnums: EnumValidValueItemModel[];

  constructor(private staticDataService: StaticDataService) {
    //
    if (this.staticDataService.validValues && this.staticDataService.validValueItems) {
      this.setValidValues();
    } else {
      this.staticDataService.validValuesReadyEvent.subscribe( {
        complete: () => {
          this.setValidValues();
        }
      });
    }
  }

  setValidValues() {
    this.toothCanalEnums = this.getValidValueItemsByName('enumToothCanal');
    this.pulpStatusEnums = this.getValidValueItemsByName('enumEndoPulpStatus');
    this.estimatedWorkLengthEnums = this.getValidValueItemsByName('enumEndoXWorkLength');
    this.referenceEnums = this.getValidValueItemsByName('enumEndoReference');
    this.actualWorkLengthEnums = this.getValidValueItemsByName('enumEndoXWorkLength');
    this.apicalCurv1LocEnums = this.getValidValueItemsByName('enumEndoApicalCurvNLoc');
    this.apicalCurv2LocEnums = this.getValidValueItemsByName('enumEndoApicalCurvNLoc');
    this.apicalCurvEnums = this.getValidValueItemsByName('enumEndoApicalCurv');
    this.firstFile2BindEnums = this.getValidValueItemsByName('enumEndoFile2Bind');
    this.masterApicalFileEnums = this.getValidValueItemsByName('enumEndoFile2Bind');
    this.guttaPerchaEnums = this.getValidValueItemsByName('enumEndoGuttaPercha');
    this.sealerEnums = this.getValidValueItemsByName('enumEndoSealer');
    this.fillEnums = this.getValidValueItemsByName('enumEndoFill');
    this.methodOfObturationEnums = this.getValidValueItemsByName('enumEndoMethodOfObturation');
    this.interAptMedEnums = this.getValidValueItemsByName('enumEndoInterAptMed');
    this.coronal1TypeEnums = this.getValidValueItemsByName('enumEndoCoronalNType');
    this.coronal2TypeEnums = this.getValidValueItemsByName('enumEndoCoronalNType');
    this.coronalPostSpaceEnums = this.getValidValueItemsByName('enumEndoCoronalPostSpace');
    this.sepEnums = this.getValidValueItemsByName('enumEndoSep');
    this.fillTypeEnums = this.getValidValueItemsByName('enumEndoFillType');
    this.fillBrandEnums = this.getValidValueItemsByName('enumEndoFillBrand');
    this.fillSizeEnums = this.getValidValueItemsByName('enumEndoFillSize');
    this.fillLocationEnums = this.getValidValueItemsByName('enumEndoFillLocation');
  }

  getValidValueItemsByName(name: string) {
    return this.staticDataService.getValidValueItemsByValidValueName(name);
  }
}
